import React from 'react';
import Navbar from './Navbar';
import SectionWithCards from "./SectionWithCards";
import './HomePage.css';
import Icon from "./Icon";
import { CardsData } from "./SectionWithCards";
import { faWallet, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';

import image1 from './assets/IMG_3449.png';
import image2 from './assets/IMG_3450.png';
import image3 from './assets/IMG_3452.png';
import image4 from './assets/IMG_3458.png';
import image5 from './assets/IMG_3454.png';
import image6 from './assets/IMG_3457.png';
import PromoComponent from "./PrompComponent";

const HomePage: React.FC = () => {

    const cardsData1 = [
        {
            imagePath: image1,
        },
    ];
    const cardsData2 = [
        {
            imagePath: image2,
        },
    ];
    const cardsData3 = [
        {
            imagePath: image3,
        },
    ];
    const cardsData4 = [
        {
            imagePath: image4,
        },
    ];
    const cardsData5 = [
        {
            imagePath: image5,
        },
    ];
    const cardsData6 = [
        {
            imagePath: image6,
        },
    ];


    return (
      <div className="HomePage">
          <PromoComponent />
          <SectionWithCards
              leftTitle="YOUR AI CHEF FOR EASY CREATIVE COOKING"
              leftText={`
              AI Chef unlocks the future of home cuisine, 
              blending technology with the timeless art of cooking. 
              Imagine having a personal chef that knows your dietary preferences, 
              the contents of your pantry, and can suggest recipes that are both nutritious and delicious. 
              This is what our app offers, powered by advanced AI technology. 
              It’s designed to inspire culinary creativity without the hassle, making cooking a joyful and effortless experience.
              `}
              //leftDisclaimer="Disclaimer: Auch die Investition in Security Token birgt ein hohes Risiko bis hin zum Totalverlust."
              cards={cardsData1}
          />
          <SectionWithCards
              leftTitle="CAPTURE YOUR FRIDGE CONTENTS"
              leftText={`
              Unlock the full potential of your kitchen with a revolutionary feature
                  that bridges the gap between what's in your fridge and your next gourmet meal.
                  By simply taking a photo of your fridge or pantry, our cutting-edge AI technology recognizes 
                  your ingredients and instantly suggests a variety of recipes you can create with them. 
                  This intuitive tool not only minimizes food waste by utilizing what you already have, 
                  but it also sparks creativity, offering new and exciting ways to combine ingredients 
                  you might not have thought of. Gone are the days of pondering what to cook for dinner; 
                  with this feature, the answer is just a snapshot away. 
                  Start exploring the endless possibilities hidden in your fridge and transform everyday ingredients 
                  into culinary delights. This is your first step towards smarter, more sustainable, and inspired cooking
                  `}
              //leftDisclaimer="Disclaimer: Auch die Investition in Security Token birgt ein hohes Risiko bis hin zum Totalverlust."
              cards={cardsData2}
          />
          <SectionWithCards
              leftTitle="AI CHEF TURNS INGREDIENTS INTO RECIPE IDEAS"
              leftText={`
              Dive into the heart of culinary innovation where magic of artificial intelligence meets your kitchen inventory.
               This feature is a game-changer for anyone looking to elevate their cooking without 
               the hassle of endless searching for recipes. By analyzing the ingredients you have,
               our AI cleverly suggests a range of recipes, from the classic favorites to the avant-garde, 
               tailored specifically to what's available to you. 
               It's like having a personal chef who not only knows your pantry inside out but also understands your 
               dietary preferences and culinary curiosity.
               Whether you're looking to whip up a quick meal with the last few items in your fridge or wanting to experiment
               with new flavor combinations, our AI makes it effortless. 
               Say goodbye to food waste and uninspired meals;
               Every ingredient is a stepping stone to your next delicious creation
               `}
              //leftDisclaimer="Disclaimer: Auch die Investition in Security Token birgt ein hohes Risiko bis hin zum Totalverlust."
              cards={cardsData3}
          />
          <SectionWithCards
              leftTitle="AI CHEF CRAFTS STUNNING RECIPES AND VISUALS"
              leftText={`
                 Dive into a world where artificial intelligence meets culinary artistry, producing not only unique,
                 tailor-made recipes but also accompanying them with stunning visuals that capture the essence of each dish.
                 This blend of innovation allows you to see the potential of your meal before it's even made,
                 inspiring you to explore new flavors and techniques.
                 Beyond the screen, the option to print or save these recipes as PDFs makes it easy to follow along
                 in the kitchen or build your own digital cookbook.
                 Whether you're a visual learner or someone who appreciates the beauty in food,
                 this approach transforms cooking from a daily task to a delightful adventure,
                 enriching your culinary experience with every dish                   `}
              //leftDisclaimer="Disclaimer: Auch die Investition in Security Token birgt ein hohes Risiko bis hin zum Totalverlust."
              cards={cardsData4}
          />
          <SectionWithCards
              leftTitle="SEARCH, SORT AND MANAGE YOUR RECIPES"
              leftText={`
                Simplify your culinary experience with intuitive tools that allow you to easily sort, search,
                and manage your collection of recipes. This feature transforms your device into a well-organized digital cookbook,
                where finding and keeping track of your favorite dishes is effortless. Whether you're planning your weekly meals
                or searching for a specific recipe, our streamlined interface ensures that everything you need is just a few taps away.
                With the ability to customize categories and save your go-to recipes, meal planning becomes a breeze,
                leaving more time for what matters most: cooking and enjoying delicious meals
                 `}
              //leftDisclaimer="Disclaimer: Auch die Investition in Security Token birgt ein hohes Risiko bis hin zum Totalverlust."
              cards={cardsData5}
          />
          <SectionWithCards
              leftTitle="TICK OFF ITEMS ON SMART SHOPPING LISTS"
              leftText={`
                Enhance your grocery shopping experience with a smart shopping list that does more than just remind you what to buy.
                Tailored to the recipes you've chosen to explore,
                this list automatically compiles all the ingredients you need,
                ensuring you never miss an item. As you navigate through the store,
                the satisfaction of ticking off items adds a level of convenience and efficiency to your shopping.
                This feature not only saves time but also aids in budgeting,
                as it helps you purchase only what's necessary for your planned meals.
                It's the perfect tool for those who love to be organized and hate making multiple trips to the store.
                With everything you need at your fingertips,
                you're free to focus on the joy of cooking and the excitement of trying new recipes
                `}
              //leftDisclaimer="Disclaimer: Auch die Investition in Security Token birgt ein hohes Risiko bis hin zum Totalverlust."
              cards={cardsData6}
          />

      </div>
  );
}

export default HomePage;
